import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-loan-settlement-negotiation-pop-up',
  templateUrl: './loan-settlement-negotiation-pop-up.component.html',
  styleUrls: ['./loan-settlement-negotiation-pop-up.component.css']
})
export class LoanSettlementNegotiationPopUpComponent implements OnInit {
  form: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public matDialogData: any,
    private dialogRef: MatDialogRef<LoanSettlementNegotiationPopUpComponent>,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    console.log("this", this.matDialogData);
    this.form = this.formBuilder.group({
      settlementAmountDemanded: new FormControl(null , [Validators.required, Validators.pattern(/^\d+$/)])
    });
  }

  initializeForm(): void { }

  resetForm(): void {
    this.form.reset();
    this.initializeForm();
  }

  onClose(data?: any): void {
    if (!this.form.valid) {
      this.dialogRef.close(null);
    } else {
      this.dialogRef.close(data);
    }
    this.resetForm();
  }

  onSubmit() {
    const formDataAndValue = {
      ...this.matDialogData,
      ...this.form.value,
    };
    console.log(this.form.value);
    this.onClose(formDataAndValue);
  }

  decline(): void {
    this.dialogRef.close();
  }
}
